<template>
	<div class="operationPersonerManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">运维人员管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title" :class="{active:active==0}" @click="changeList(0)">运维人员列表</span>
					<span class="linBox"></span>
					<span class="title" :class="{active:active==1}" @click="changeList(1)">运维承包商</span>
				</div>
				<!-- <div class="icon_add iconBox" @click="itemClick({},5)" title="新增运维人员"></div> -->
			</div>
			<div v-if="active==0">
				<personnelList></personnelList>
			</div>
			<div v-else>
				<contractorList></contractorList>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import personnelList from "./personnelList/personnelList.vue"
	import contractorList from "./contractorList/contractorList.vue"
	export default {
		name: "operationPersonerManage",
		components: {
			personnelList,
			contractorList
		},
		data() {
			let that = this;
			return {
				active:0,
			}
		},
		mounted() {
			this.$nextTick(() => {
				// this.getData()
				// this.getAreaList()
				// if (!(localStorage.getItem("areaList"))) {
				// 	this.getAreaList()
				// } else {
				// 	this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				// }
			})
		},
		methods: {
			changeList(n) {
				this.active = n
				// this.searchObj.pageNo = 1
				// this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					// this.getData(n)
				})
			
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./operationPersonerManage.scss";
</style>